<template>
    <div id="Accounts">
        <nav-bar>
            <div slot="left">
                <van-icon name="arrow-left" color="#666666" size="20" @click="goBack"/>
            </div>
            <div slot="title" style="font-weight: 800; font-size: 15px;  letter-spacing:2px;">{{langText.accountsSecurity}}</div>
        </nav-bar>
        <div style="height: 60px; width: 100%;"></div>


        <van-form>
            <div style="width: 95%; margin: auto; ">
                <van-cell-group style="border-radius: 10px;">
                    <van-cell style="border-top-right-radius: 10px; border-top-left-radius: 10px;"   :title="langText.memberId" >
                        <span> {{loginFrom.accountname}} </span>
                    </van-cell>

                    <van-cell   :title="langText.phone" is-link   @click="setPhone">
                       <span> {{telephone}} </span>
                    </van-cell>

                    <van-cell style="border-bottom-right-radius: 10px; border-bottom-left-radius: 10px;" :title="langText.changingPassword" is-link @click="updatePassword">

                    </van-cell>

<!--                    <van-cell style="border-bottom-right-radius: 10px; border-bottom-left-radius: 10px;" is-link @click="showPopup2">{{langText.paymentPassword}}</van-cell>-->

                </van-cell-group>
<!--                <van-field-->
<!--                        v-model="loginFrom.telephone"-->
<!--                        name="手机号码"-->
<!--                        label="手机号码"-->
<!--                        placeholder="手机号码"-->
<!--                />-->


            </div>

        </van-form>
    </div>
</template>

<script>
    import NavBar from "@/components/common/navbar/NavBar";
    import {getAccounts} from "../../network/mine/account"
    import { Col, Row, Icon, Image, Divider,Form, Field, Cell, CellGroup} from 'vant'

    import { langPackage } from "@/config/lang/accountsLang";
    import { selectLang } from "@/config/setLanguage";


    export default {
        name: "Accounts",
        components: {
            NavBar: NavBar,
            [Col.name]: Col,
            [Row.name]: Row,
            [Icon.name]: Icon,
            [Image.name]: Image,
            [Divider.name]: Divider,
            [Form.name]: Form,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field
        },
        data(){
            return{
                loginFrom:{
                    accountname:"agg123456789",
                    telephone:""
                },
                title:"输入绑定手机号",
                lang:"cn",
                langText:{},
                commonText:{},
            }
        },
        methods:{
            goBack(){
                this.$router.push({ path: '/mine'});
            },
            showPopup2(){
                this.$router.push({path: '/mine/setUserPay'})
            },
            setPhone(){
                this.$router.push({path: '/mine/accounts/GetUserPhone'})
            },
            updatePassword(){
                this.$router.push({path: '/mine/accounts/updatePassword'})
            }


        },
        computed:{
            telephone:function(){
                let telephone = this.loginFrom.telephone;
                if(telephone.length != 11 || telephone == ''){
                    return this.title;
                }
                telephone = telephone.replace(telephone.substring(3,telephone.length - 2), '******')
                return telephone;
            }
        },
        created() {
            //获取语言包
            selectLang(langPackage).then(langtxt =>{
                this.langText = langtxt.langtxt;
                this.commonText = langtxt.common;
            });

            //获取基本信息
            getAccounts().then((res)=>{
                if (res.code == 200){
                    this.loginFrom.accountname = res.data.username
                    if (res.data.phone.length == 11 && res.data.phone != null){
                        this.loginFrom.telephone = res.data.phone;
                    }
                }
            });


        }
    }
</script>

<style scoped>

    #Accounts{
        background: #f8f6f7;
        /*height: 800px;*/
        width: 100%;
    }

</style>
